import { render, staticRenderFns } from "./CounterItem.vue?vue&type=template&id=6d40e2bf"
import script from "./CounterItem.vue?vue&type=script&lang=js"
export * from "./CounterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports